import {useLocale, useTranslation} from '@aboutyou/i18n';
import {AdjustTracker} from '@aboutyou/tracking';
import {StoreBadge, UnstyledLink} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {AdjustDeepLinkType, useGetStoreLink} from './utils/useGetStoreLink';

interface StoreBadgeProps {
  className?: string;
  dataTestId?: string;
  deepLink: AdjustDeepLinkType;
  height?: number;
  onClick?: VoidFunction;
  adjustTracker: AdjustTracker;
}

export const StoreBadges: React.FC<StoreBadgeProps> = ({
  className,
  dataTestId = 'storeBadges',
  deepLink,
  height = 30,
  onClick,
  adjustTracker,
}) => {
  const {t} = useTranslation();
  const locale = useLocale();
  const storeLink = useGetStoreLink({adjustTracker, deepLink});

  return (
    <Wrapper
      data-testid={dataTestId}
      className={className}
      to={storeLink}
      onClick={onClick}
      aria-label={t('Download app')}
    >
      <StoreBadge height={height} locale={locale} provider="ios" />
      <StoreBadge height={height} locale={locale} provider="android" />
    </Wrapper>
  );
};

const Wrapper = styled(UnstyledLink)`
  display: flex;
  align-items: center;
  gap: 6px;
`;
